'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var Autocomplete = require('./Autocomplete-dbb3d852.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".DestAutoComplete_module_visuallyHidden__22ee88e0 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.DestAutoComplete_module_youtubeVideo__22ee88e0 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.DestAutoComplete_module_AutoComplete__22ee88e0 {\n  min-width: 320px;\n  margin-right: 24px;\n  z-index: 3;\n}\n@media (max-width: 768px) {\n  .DestAutoComplete_module_AutoComplete__22ee88e0 {\n    min-width: auto;\n    width: 100%;\n    max-width: none;\n  }\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/DestinationAutoComplete/DestAutoComplete.module.scss");
var modules_8a12ee83 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"DestAutoComplete_module_visuallyHidden__22ee88e0","youtubeVideo":"DestAutoComplete_module_youtubeVideo__22ee88e0","AutoComplete":"DestAutoComplete_module_AutoComplete__22ee88e0"};

function DestAutoComplete(_ref) {
  var extraClass = _ref.extraClass,
    id = _ref.id,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Enter Destination" : _ref$placeholder,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Enter Destination" : _ref$label,
    _ref$useResponseValue = _ref.useResponseValues,
    useResponseValues = _ref$useResponseValue === void 0 ? false : _ref$useResponseValue,
    _ref$filterMismatchin = _ref.filterMismatchingValues,
    filterMismatchingValues = _ref$filterMismatchin === void 0 ? false : _ref$filterMismatchin,
    inputName = _ref.inputName,
    airports = _ref.airports,
    cities = _ref.cities,
    cars = _ref.cars;
  var _useState = React.useState([]),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    termsList = _useState2[0],
    setList = _useState2[1];
  var _useState3 = React.useState({}),
    _useState4 = _rollupPluginBabelHelpers._slicedToArray(_useState3, 2),
    autocompleteValueMap = _useState4[0],
    setAutocompleteValueMap = _useState4[1];
  var _useState5 = React.useState(""),
    _useState6 = _rollupPluginBabelHelpers._slicedToArray(_useState5, 2),
    autoCompleteValue = _useState6[0],
    setAutoCompleteValue = _useState6[1];
  React.useEffect(function () {
    if (autoCompleteValue != undefined && autoCompleteValue.length >= 3) {
      if (cars == true) {
        fetch('https://aaanational.tstllc.net/web-services/common/autocomplete?options=["airports","places"]&term=' + autoCompleteValue).then(function (res) {
          return res.json();
        }).then(function (carsResponse) {
          // If specified
          // Filter OUT results where label and value are equal
          if (filterMismatchingValues) carsResponse.places = carsResponse.places.filter(function (x) {
            return x.value != x.label;
          });
          var dynamicList = carsResponse.places.map(function (item) {
            return item.label;
          });
          setList(dynamicList);

          // If we want to use values, not labels
          // We'll need to save a map of label=> value for later
          if (useResponseValues) {
            var newMap = dynamicList.reduce(function (accumulator, currentValue) {
              return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, accumulator), {}, _rollupPluginBabelHelpers._defineProperty({}, currentValue, carsResponse.places.find(function (x) {
                return x.label == currentValue;
              }).value));
            }, autocompleteValueMap);
            setAutocompleteValueMap(newMap);
          }
        });
      } else if (cities == true) {
        fetch('https://aaanational.tstllc.net/web-services/common/autocomplete?options=["cities"]&term=' + autoCompleteValue).then(function (res) {
          return res.json();
        }).then(function (citiesResponse) {
          // If specified
          // Filter OUT results where label and value are equal
          if (filterMismatchingValues) citiesResponse.cities = citiesResponse.cities.filter(function (x) {
            return x.value != x.label;
          });
          var citiesDynamicList = citiesResponse.cities.map(function (item) {
            return item.label;
          });
          setList(citiesDynamicList);

          // If we want to use values, not labels
          // We'll need to save a map of label=> value for later
          if (useResponseValues) {
            var newMap = citiesDynamicList.reduce(function (accumulator, currentValue) {
              return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, accumulator), {}, _rollupPluginBabelHelpers._defineProperty({}, currentValue, citiesResponse.cities.find(function (x) {
                return x.label == currentValue;
              }).value));
            }, autocompleteValueMap);
            setAutocompleteValueMap(newMap);
          }
        });
      } else if (airports == true) {
        fetch('https://aaanational.tstllc.net/web-services/common/autocomplete?options=["airports"]&term=' + autoCompleteValue).then(function (res) {
          return res.json();
        }).then(function (airResponse) {
          var airports = airResponse.airports;

          // If specified
          // Filter OUT results where label and value are equal (no airport code)
          // Only accept results that have a 3 letter value
          airports = airports.filter(function (x) {
            return x.value.length == 3;
          });
          var airDynamicList = airports.map(function (item) {
            return item.label;
          });
          setList(airDynamicList);

          // If we want to use values, not labels
          // We'll need to save a map of label=> value for later
          if (useResponseValues) {
            var newMap = airDynamicList.reduce(function (accumulator, currentValue) {
              return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, accumulator), {}, _rollupPluginBabelHelpers._defineProperty({}, currentValue, airports.find(function (x) {
                return x.label == currentValue;
              }).value));
            }, autocompleteValueMap);
            setAutocompleteValueMap(newMap);
          }
        });
      } else {
        fetch('https://aaanational.tstllc.net/web-services/common/autocomplete?options=["hotels","airports","cities"]&term=' + autoCompleteValue).then(function (res) {
          return res.json();
        }).then(function (response) {
          // If specified
          // Filter OUT results where label and value are equal
          if (filterMismatchingValues) response.places = response.places.filter(function (x) {
            return x.value != x.label;
          });
          var dynamicList = response.places.map(function (item) {
            return item.label;
          });
          setList(dynamicList);

          // If we want to use values, not labels
          // We'll need to save a map of label=> value for later
          if (useResponseValues) {
            var newMap = dynamicList.reduce(function (accumulator, currentValue) {
              return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, accumulator), {}, _rollupPluginBabelHelpers._defineProperty({}, currentValue, response.airports.find(function (x) {
                return x.label == currentValue;
              }).value));
            }, autocompleteValueMap);
            setAutocompleteValueMap(newMap);
          }
        });
      }
    } else {
      setList([]);
    }
  }, [autoCompleteValue]);

  // if for the 'autoCompleteValue' there is an associated key in the 'autocompleteValueMap'
  // Then use the value associated with that key
  // Otherwise, if no value map, or no assicated key, use the bare value
  var trueValue = autocompleteValueMap !== null && autocompleteValueMap !== void 0 && autocompleteValueMap[autoCompleteValue] ? autocompleteValueMap === null || autocompleteValueMap === void 0 ? void 0 : autocompleteValueMap[autoCompleteValue] : autoCompleteValue;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    id: id,
    name: inputName,
    value: trueValue
  }), /*#__PURE__*/React__default["default"].createElement(Autocomplete.Autocomplete, {
    extraClass: [modules_8a12ee83.AutoComplete, extraClass].join(" "),
    label: label,
    id: id + "-autocomplete-input",
    name: inputName + "-autocomplete-input",
    placeholder: placeholder,
    dynamicList: termsList,
    value: autoCompleteValue,
    onChange: function onChange(e) {
      return setAutoCompleteValue(e.target.value);
    }
  }));
}
DestAutoComplete.propTypes = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({
  extraClass: index.propTypes.exports.string,
  id: index.propTypes.exports.string,
  filterMismatchingValues: index.propTypes.exports.bool,
  useResponseValues: index.propTypes.exports.bool,
  placeholder: index.propTypes.exports.string,
  label: index.propTypes.exports.string
}, "id", index.propTypes.exports.string), "inputName", index.propTypes.exports.string), "airports", index.propTypes.exports.bool), "cities", index.propTypes.exports.bool), "cars", index.propTypes.exports.bool);

exports.DestAutoComplete = DestAutoComplete;
